import { API_BASE_URL, environment } from "src/environments/environment";

// const valueToCompare: string = 'http://api.portal-server-homolog.apps.ocp.sema.mt.gov.br';

// const API_URL_ENV = API_BASE_URL;
// const API_URL_HOMLOG = 'http://api.alerta-server-homolog.apps.ocp.sema.mt.gov.br/api';

// const API_URL = valueToCompare ===  environment.URL_ME ? API_URL_HOMLOG : API_URL_ENV;

const API_URL = API_BASE_URL;

export default API_URL;

